/*
  About Form - about tab
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

/* Formik and Yup */
import { Formik } from 'formik';
import * as Yup from 'yup';

import { toggleChangesModal } from 'data_system/resource_portal/actions/experienceActions';
import { t } from 'services/translation';
import AboutForm from './AboutForm';

// TODO - propTypes

class AboutContainer extends Component {
  constructor(props) {
    super(props);
    const schema = Yup.object().shape({
      name: Yup.string().trim().required(t('PLEASE_ENTER_A_NAME')),
      tagline: Yup.string().trim().required(t('PLEASE_ENTER_A_SUBTITLE')),
      description: Yup.string()
        .trim()
        .required(t('PLEASE_ENTER_A_DESCRIPTION')),
    });

    const customFields = this.addCustomFieldsToSchema();
    this.validationSchema = schema.concat(customFields);
  }

  // Custom Fields

  onSubmitForm = (values, _actions) => {
    const apiValues = this.apiValues(values);
    this.props.handleSubmit({
      step: 'about',
      apiValues,
    });
  };

  addCustomFieldsToSchema = () => {
    const { experience } = this.props;
    const { customFields } = experience;
    if (!(customFields.data.length > 0)) return Yup.object().shape({});

    let listSchema = Yup.object().shape({});
    customFields.data.forEach((f) => {
      const { inputType } = f.attributes;
      if (inputType === 'list') {
        const newListSchema = Yup.object().shape({
          [`toggleCustomField${f.id}`]: Yup.boolean(),
          [`customField${f.id}`]: Yup.object()
            .required('Required field')
            .shape({
              experienceQuestionId: Yup.string().nullable(),
              questionAnswers: Yup.array().of(
                Yup.object().shape({
                  quantity: Yup.string().nullable(),
                  supplyUrl: Yup.string().nullable(),
                  textAnswer: Yup.string().required(
                    t('PLEASE_FILL_OUT_OR_REMOVE_ANY_EMPTY_ROWS')
                  ),
                })
              ),
            }),
        });
        listSchema = listSchema.concat(newListSchema);
      } else if (inputType === 'select' || inputType === 'radio') {
        const newFieldSchema = Yup.object().shape({
          [`customField${f.id}`]: Yup.object().shape({
            questionOptionId: Yup.string()
              .nullable()
              .required(t('PLEASE_SELECT_AN_OPTION')),
          }),
        });
        listSchema = listSchema.concat(newFieldSchema);
      } else if (inputType === 'text') {
        const newFieldSchema = Yup.object().shape({
          [`customField${f.id}`]: Yup.object().shape({
            textAnswer: Yup.string()
              .nullable()
              .required(t('PLEASE_PROVIDE_AN_ANSWER')),
          }),
        });
        listSchema = listSchema.concat(newFieldSchema);
      }
    });
    return listSchema;
  };

  apiValues = (rawValues) => {
    if (rawValues.description.replace(/(<([^>]+)>)/gi, '') === '') {
      rawValues.description = '';
    }
    const values = this.validationSchema.cast(rawValues);

    return values;
  };

  addCustomFieldsToFormValues = (values) => {
    const { experience } = this.props;
    const { customFields } = experience;
    // TODO: clean up (shorten)
    customFields.data.forEach((f) => {
      const answer =
        f.attributes.questionAnswers &&
        f.attributes.questionAnswers.data.length > 0
          ? f.attributes.questionAnswers.data[0].attributes
          : null;
      values[`customField${f.id}`] = {
        experienceQuestionId:
          f.attributes.questionAnswers && parseInt(f.attributes.id, 10),
        questionOptionId: answer && answer.questionOptionId,
        textAnswer: answer && answer.textAnswer,
      };
      // --

      // Adds questionAnswers to input types that need em
      if (f.attributes.inputType === 'list') {
        const items = f.attributes.questionAnswers
          ? f.attributes.questionAnswers.data.map((qa) => {
              return {
                id: qa.id,
                textAnswer: qa.attributes.textAnswer,
                quantity: qa.attributes.quantity || '',
                quantityPlaceholder: t('QUANTITY'),
                supplyUrl: qa.attributes.supplyUrl || '',
                supplyUrlPlaceholder: t('OPTIONAL_URL'),
              };
            })
          : [];

        values[`customField${f.id}`].questionAnswers = items;
        if (f.attributes.inputType === 'list') {
          values[`toggleCustomField${f.id}`] = items && items.length > 0;
        }
      }
    });
  };

  initialValues = () => {
    const { experience } = this.props;
    // Default/initial values to populate form (new)
    let initialValues = {
      name: null,
      tagline: null,
      description: null,
    };

    if (!experience) {
      return initialValues;
    }

    const { name, tagline, description, customFields } = experience;

    initialValues = {
      name,
      tagline,
      description,
    };

    if (customFields.data.length > 0) {
      this.addCustomFieldsToFormValues(initialValues);
    }

    return initialValues;
  };

  render() {
    return (
      <Formik
        render={(formikProps) => (
          <AboutForm {...formikProps} i18n={this.props.i18n} />
        )}
        initialValues={this.initialValues()}
        validationSchema={this.validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => this.onSubmitForm(values, actions)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { experienceReducer } = state;
  return {
    experience: experienceReducer.experience,
    experienceStepForm: experienceReducer.experienceStepForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ toggleChangesModal }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AboutContainer));
